// © Microsoft Corporation. All rights reserved.

import { css } from "@microsoft/fast-element";
import { PublisherCarouselTheme } from "./PublisherCarouselData";

/** Style definitions for PublisherCarousel */
export const PublisherCarouselStyles = css`
    msft-stripe {
        box-sizing: border-box;
        display: block;
    
        --background-color: transparent;
        --scroll-item-spacing: 12px;
    }
    msft-stripe > fluent-anchor {
        align-items: center;
    }
    msft-stripe .carousel-title {
        font-size: 18px;
        text-decoration: none;
    }
    msft-stripe .about-slug-glyph {
        cursor: pointer;
        fill: var(--neutral-foreground-rest);
        margin: 8px;
    }

    msft-stripe::part(scroll-next), msft-stripe::part(scroll-prev) {
        z-index: 1;
    }
    msft-content-card::part(media-wrapper) {
        margin: 0;
    }
    msft-content-card .select-carousel-item-body {
        width: 100%;
        padding-bottom: 5px;
    }

    msft-stripe > fluent-card {
        width: 220px;
        --content-card-corner-radius: 0;
    }
    msft-stripe > fluent-card msft-content-card::part(heading-container){
        padding: 10px 12px 0;
        --heading-font-size: 14px;
        --heading-line-height: 20px;
    }

    /** SUBSCRIPTION BADGE */
    .subscription-badge-container {
        margin: -6px 0 6px;
        padding: 0;
    }
    .subscription-badge {
        border: 1px solid gray;
        border-color: gray;
        border-radius: 4px;
        font-size: 8px;
        font-weight: bold;
        letter-spacing: .7pt;
        padding: 2px 5px 3px;
        text-transform: uppercase;
        
    }
    .subscription-badge.subscribed {
        background: linear-gradient(90deg, rgba(92, 65, 225, 1) 0%, rgba(140, 142, 255, 1) 100%);
        border: none;
        color: white;
        padding: 2px 7px 3px;
    }
`;

/** Themes */
const imageSizes = {
    [PublisherCarouselTheme.default]: { width: 220, height: 124 },
    [PublisherCarouselTheme.articlePage]: { width: 220, height: 178 }
};

export const PublisherCarouselThemeStyles = {
    [PublisherCarouselTheme.default]: {
        carousel: css`
            /** CUSTOM BACKGROUND */
            .background-sheet {
                background: white;
                position: absolute;
                height: 320px;
                width: 100vw;
                margin-left: -50vw;
                left: 50%;
            }

            /** STRIPE */
            msft-stripe {
                height: 320px;
                padding: 24px 0;
            }
            msft-stripe:before {
                height: 320px;
            }
            msft-stripe .carousel-title {
                color: rgba(0, 0, 0, 0.83);
            }
            fluent-anchor {
                color: rgba(0, 0, 0, 0.83);
            }
            fluent-anchor:hover::part(content):before {
                color: rgba(0, 0, 0, 0.83);
            }
            fluent-card {
                height: 230px;
            }
        `,
        card: null,
        imageSize: imageSizes[PublisherCarouselTheme.default]
    },
    [PublisherCarouselTheme.articlePage]: {
        carousel: css`
            /** CUSTOM BACKGROUND */
            .background-sheet {
                background: linear-gradient(180deg, #0000 0%, #00000010 100%);
                position: absolute;
                width: 100vw;
                margin-left: -50vw;
                left: 50%;
                height: 351px;
            }

            /** STRIPE */
            msft-stripe {
                height: 351px;
                padding: 12px 0;
            }

            fluent-card {
                height: 286px;
                --elevated-corner-radius: 6;
            }
        `,
        card: null,
        imageSize: imageSizes[PublisherCarouselTheme.articlePage]
    }
};
